import {operationFailureHandler} from '@/utils/operationFeedback'
import request from '@/utils/request'
import store from '@/store'
export default {
  // 2026-09-29：平台只读分店全部商品，筛选及统计由服务端统一分页。
  getBranchProductAnalysis: (data) => request({url:'product/branchProductAnalysis',method:'POST',data}),
  // 2026-09-14：按登录机构保存全店版型开关，成衣开关额外绑定基础版型。
  getPatternMediaVisibility: () => request({url:'product/patternMediaVisibility',method:'GET'}),
  savePatternMediaVisibility: (data) => request({url:'product/patternMediaVisibility',method:'POST',data}),
  getCustomClothMediaVisibility: (id:number) => request({url:`product/customClothMediaVisibility?prdid=${id}`,method:'GET'}),
  saveCustomClothMediaVisibility: (id:number,data) => request({url:`product/customClothMediaVisibility?prdid=${id}`,method:'POST',data}),
  getProducts: (data) => {
    return request({
      url: 'product/allProducts',
      method: 'POST',
      data
    })
  },
  getUpSharedProducts: (data) => {
    return request({
      url: 'product/upSharedProducts',
      method: 'POST',
      data
    })
  },
  
  getBranchBokes: (data) => {
    return request({
      url: 'product/branchBokes',
      method: 'POST',
      data
    })
  },
  getFabricBindingCloths: (data) => request({url:'product/fabricBindingCloths',method:'POST',data}),
  getParentSharedProducts: (data) => {
    return request({
      url: 'product/parentSharedProducts',
      method: 'POST',
      data
    })
  },
  // 2026-08-31：分店平台商品页单独读取和保存“不自动引用”，不把该状态混入商品筛选条件。
  getProductAutoReferencePreference: () => {
    return request({
      url: 'product/autoReferencePreference',
      method: 'GET'
    })
  },
  updateProductAutoReferencePreference: (disabled:boolean) => {
    return request({
      url: `product/autoReferencePreference?disabled=${disabled}`,
      method: 'POST',
      // 2026-09-22：全店取消引用需要事务处理，仅此批量设置延长等待，避免20秒误判失败后重复提交。
      timeout: 120000
    })
  },
  getGroupedProducts: (data) => {
    return request({
      url: 'product/groupedProducts',
      method: 'POST',
      data
    })
  },
  
  getTemplateProducts: (data) => {
    return request({
      url: 'product/templateProducts',
      method: 'POST',
      data
    })
  },  
  getCountByProductCode:(code)=>{
    return request({
      url: `product/countByProductCode?code=${code}`,
      method: 'GET'
    })
  },
  // 2026-10-14：仅明确需要的版型详情保留HTTP/业务错误，其他调用方维持原行为。
  addProduct: (data,preserveErrorDetails=false) => {
    return request({
      preserveErrorDetails,
      url: 'product/addProduct',
      method: 'POST',
      data
    })
  },
  setTopCover: (id) => {
    return request({
      url: `product/setTopCover?id=${id}`,
      method: 'GET'
    })
  },
  getProductCode: (type) => {
    return request({
      url: `product/productCode?productType=${type}`,
      method: 'GET'
    })
  },
  addTemplateProduct: (data) => {
    return request({
      url: 'product/addTemplateProduct',
      method: 'POST',
      data
    })
  },  
  updateProduct: (data) => {
    return request({
      url: 'product/updateProducts',
      method: 'POST',
      data
    })
  },  
  // 2026-10-14：仅明确需要的版型详情保留HTTP/业务错误，其他调用方维持原行为。
  saveProductSize: (data,preserveErrorDetails=false) => {
    return request({
      preserveErrorDetails,
      url: 'product/productSize',
      method: 'POST',
      data
    })
  },  
  getOrderAttachs: ({ids},callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/product/orderAttachs?detailIds=${ids}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(operationFailureHandler('下载未完成，请检查网络后重试。'));
  },
  getOrderAttachsCustom: ({ids,downBoke},callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/product/orderAttachsCustom?detailIds=${ids}&downBoke=${downBoke}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(operationFailureHandler('下载未完成，请检查网络后重试。'));
  },
  getOrderAttachCustom: ({id,downBoke},callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/product/orderAttachCustom?orderDetailId=${id}&downBoke=${downBoke}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(operationFailureHandler('下载未完成，请检查网络后重试。'));
  },
  getOrderAttach: ({id},callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/product/orderAttach?orderDetailId=${id}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(operationFailureHandler('下载未完成，请检查网络后重试。'));
  },
  
  // 2026-09-10：量体附件下载向页面传播额度、到期和 JSON 错误，避免将业务错误保存为 ZIP。
  getOrderAttachsByIds: async (ids):Promise<Blob> => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      const idss=Array.isArray(ids)?ids.join('-'):ids.toString()
      const response=await fetch(process.env.VUE_APP_BASE_API+`/product/orderAttachsByIds?ids=${idss}`, requestOptions as any)
      const blob=await response.blob()
      const prefix=(await blob.slice(0,256).text()).trimStart()
      if(/json/i.test(blob.type) || /^(?:\{|\[)/.test(prefix)){
        let errorMessage='附件下载失败，请稍后重试'
        try{
          const result=JSON.parse(await blob.text())
          if(typeof result?.message==='string' && result.message) errorMessage=result.message
          else if(typeof result?.msg==='string' && result.msg) errorMessage=result.msg
        }catch(_error){
          errorMessage='附件下载结果异常，请稍后重试'
        }
        throw new Error(errorMessage)
      }
      if(!response.ok) throw new Error(`附件下载失败，状态码：${response.status}`)
      return blob
  },
  getProductsForbinding: (data) => {
    return request({
      url: 'product/productsForbinding',
      method: 'POST',
      data
    })
  },
  upSharedToPlatofromProducts: (data) => {
    return request({
      url: `product/upSharedToPlatofromProducts`,
      method: 'POST',
      data
    })
  },
  upSharedToBranchProducts: (data) => {
    return request({
      url: `product/upSharedToBranchProducts`,
      method: 'POST',
      data
    })
  },
  getAttachs: ({id,type,size},callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/product/attach-files?prdid=${id}&type=${type}&size=${size}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(operationFailureHandler('下载未完成，请检查网络后重试。'));
  },
  downloadProductAttachs: ({id},callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/product/downloadProductAttachs?productId=${id}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(operationFailureHandler('下载未完成，请检查网络后重试。'));
  },
  downloadProducAlltAttachs: ({id},callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/product/downloadProductAllAttachs?productId=${id}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(operationFailureHandler('下载未完成，请检查网络后重试。'));
  },
  getProductSharingByProductId: (id) => {
    return request({
      url: `product/productSharingByProductId?productId=${id}`,
      method: 'GET'
    })
  },
  getPlatformProductWithReffing: (data) => {
    return request({
      url: 'product/platformProductWithReffing',
      method: 'POST',
      data
    })
  },
  saveSharedProduct: (data) => {
    return request({
      url: 'product/sharedProduct',
      method: 'POST',
      data
    })
  },
  // 2026-08-04：成衣定制使用独立保存接口，以支持草稿和提交审核两种动作。
  saveCustomCloth: (data,submitAudit=false) => {
    return request({
      url: `product/customCloth?submitAudit=${submitAudit}`,
      method: 'POST',
      data
    })
  },
  // 2026-08-04：撤销成衣定制审核后恢复草稿，供页面重新修改并提交。
  cancelCustomClothAudit: (kid) => {
    return request({
      url: `product/cancelCustomClothAudit?kid=${kid}`,
      method: 'POST'
    })
  },
  // 2026-08-17：按成衣定制面料记录读取审核详情，由后端固定当前机构与对应申请单。
  getCustomClothAuditedInfo: (kid) => {
    return request({
      url: `product/customClothAuditedInfo?kid=${kid}`,
      method: 'GET'
    })
  },
  // 2026-08-10：面料颜色关闭使用独立接口，保留历史订单、附件和 OSS 文件。
  closeCustomCloth: (kid) => {
    return request({
      url: `product/customCloth?kid=${kid}`,
      method: 'DELETE'
    })
  },
  saveParentSharedProduct: (data) => {
    return request({
      url: 'product/saveParentSharedProduct',
      method: 'POST',
      data
    })
  },  
  delParentSharedProduct: (id) => {
    return request({
      url: `product/parentSharedProduct?id=${id}`,
      method: 'DELETE',
      
    })
  },  
  getDownSharingProduct: (id) => {
    return request({
      url: `product/downSharingProduct?id=${id}`,
      method: 'GET',
      
    })
  },
  setShareProductMounted: (id,mounted) => {
    return request({
      url: `product/shareProductMounted?id=${id}&mounted=${mounted}`,
      method: 'GET',
      
    })
  },
  addProductSharings: (data) => {
    return request({
      url: 'product/productSharing',
      method: 'POST',
      data
    })
  },
  addProductReffing: (data) => {
    return request({
      url: 'product/productreffing',
      method: 'POST',
      data
    })
  },
  updateProductsUpShare: (ids,salesPlatformId) => {
    return request({
      url: `product/updateProductsUpShare?salesPlatformId=${salesPlatformId}&ids=${ids}`,
      method: 'GET'
    })
  },
  getProductAttachs: (prdId,type) => {
    return request({
      url: `product/productAttachs?productId=${prdId}&type=${type}`,
      method: 'GET'
    })
  },
  getSharedProducts: (prdId) => {
    return request({
      url: `product/sharedProducts?productId=${prdId}`,
      method: 'GET'
    })
  },
  
  patchMountProducts: (orgId,type,status,productType) => {
    return request({
      url: `product/patchMountProducts?orgId=${orgId}&type=${type}&status=${status}&productType=${productType}`,
      method: 'GET'
    })
  },
  UpdateDownsharing: (data) => {
    return request({
      url: 'product/downsharing',
      method: 'POST',
      data
    })
  },
  updateAttachStatus: (status,id) => {
    return request({
      url: `product/updateAttachStatus?status=${status}&id=${id}`,
      method: 'GET'
    })
  },
  syncProduct: (orgId,parentId) => {
    return request({
      url: `product/syncProductsToNewOrg?orgId=${orgId}&parentId=${parentId}`,
      method: 'GET'
    })
  },
  addFabric: (data) => {
    return request({
      url: 'product/fabric',
      method: 'POST',
      data
    })
  },
  // 2026-10-14：仅明确需要的版型详情保留HTTP/业务错误，其他调用方维持原行为。
  editProduct: (data,preserveErrorDetails=false) => {
    return request({
      preserveErrorDetails,
      url: 'product/editProduct',
      method: 'POST',
      data
    })
  },
  editTemplateProduct: (data) => {
    return request({
      url: 'product/editTemplateProduct',
      method: 'POST',
      data
    })
  },  
  addProductsFabric: (data) => {
    return request({
      url: 'product/addProductsFabric',
      method: 'POST',
      data
    })
  },
  addProductsDecoration: (data) => {
    return request({
      url: 'product/addProductsDecoration',
      method: 'POST',
      data
    })
  },
  getProductTemplate: (data) => {
    return request({
      url: 'product/productTemplate',
      method: 'POST',
      data
    })
  },
  getSystemProducts: (data) => {
    return request({
      url: 'product/systemProduct',
      method: 'POST',
      data
    })
  },
  saveSystemProduct: (data) => {
    return request({
      url: 'product/systemProductAding',
      method: 'POST',
      data
    })
  },
  patchLoadProducts: (data) => {
    return request({
      url: 'product/patchLoadProducts',
      method: 'POST',
      data
    })
  },
  deleteFabric:(id) => {
    return request({
      url: `product/fabric?id=${id}`,
      method: 'DELETE'      
    })
  },
  deleteFabrics:({productId,attachId}) => {
    return request({
      url: `product/fabrics?productId=${productId}&fabricId=${attachId}`,
      method: 'DELETE'      
    })
  },
  deleteDecorations:({productId,attachId}) => {
    return request({
      url: `product/decrorations?productId=${productId}&decorationId=${attachId}`,
      method: 'DELETE'      
    })
  },
  deleteDecoration:(id) => {
    return request({
      url: `product/decroration?id=${id}`,
      method: 'DELETE'      
    })
  },
  getGroupProduct: (sizeGroupId,orgId,id) => {
    return request({
      url: `product/groupProduct?orgId=${orgId}&sizeGroupId=${sizeGroupId}&id=${id}`,
      method: 'GET',
    })
  },
  getProduct: (id) => {
    return request({
      url: 'product/product/'+id,
      method: 'GET',
    })
  },
  getSharingProducts: (id) => {
    return request({
      url: 'product/crossProduct?sharingId='+id,
      method: 'GET',
    })
  },
  getProductOnly: (id) => {
    return request({
      url: 'product/productOnly?productId='+id,
      method: 'GET',
    })
  },
  
  // 2026-08-06：删除成衣子项时可要求后端保留与父商品共用的 OSS 图片。
  delProduct: (id,preserveFiles=false) => {
    return request({
      url: `product/deleteProduct/${id}?preserveFiles=${preserveFiles}`,
      method: 'DELETE',
    })
  },
  updateProductStatus: (id,status) => {
    return request({
      url: `product/updateProductStatus?id=${id}&status=${status}`,
      method: 'GET',
    })
  },
  updateSizeGroupProductStatus: (sizeGroup,status) => {
    return request({
      url: `product/updateSizeGroupProductStatus?sizeGroup=${sizeGroup}&status=${status}`,
      method: 'GET',
    })
  },
  getDecorationsByProductId: (orgId,productId) => {
    return request({
      url: `product/decorationsByProductId?orgId=${orgId}&productId=${productId}`,
      method: 'GET',
    })
  },
  getFabricsByProductId: (orgId,productId) => {
    return request({
      url: `product/fabricsByProductId?orgId=${orgId}&productId=${productId}`,
      method: 'GET',
    })
  },
  getTemplateProduct: (id) => {
    return request({
      url: 'product/templateProduct/'+id,
      method: 'GET',
    })
  },
  
  getProductSizeNames: (id) => {
    return request({
      url: 'product/allProductSizeNams/'+id,
      method: 'GET',
    })
  },
  deleteProductAttach: (id) => {
    return request({
      url: 'product/deleteProductsAttach/'+id,
      method: 'DELETE',
    })
  },
  deleteSharedAttach: (id) => {
    return request({
      url: 'product/sharedAttach?id='+id,
      method: 'DELETE',
    })
  },
  getFabrics: (orgId) => {
    return request({
      url: `product/fabrics?orgId=${orgId}`,
      method: 'GET',
    })
  },
  updateDownShared: (downShared,id,ids) => {
    return request({
      url: `product/updateDownShared?downShared=${downShared}&id=${id}&ids=${ids}`,
      method: 'GET',
    })
  },
  productMounted: (data) => {
    return request({
      url: 'product/editProductMounted',
      method: 'POST',
      data
    })
  },
  saveCrossSharing: (data) => {
    return request({
      url: 'product/crossProduct',
      method: 'POST',
      data
    })
  },
  getReceiver: () => {
    return request({
      url: `sftpay/personalReceiver`,
      method: 'GET',
    })
  },  
  // 2026-09-16：头版可携带整款申请ID，原单项路径和参数继续兼容。
  mountSharingProduct: (id,mounted,ids?:string) => {
    return request({
      url: `product/mountSharingProduct?id=${id}&mounted=${mounted}${ids?'&ids='+encodeURIComponent(ids):''}`,
      method: 'GET',
    })
  },
  deleteGroup: (id) => {
    return request({
      url: `product/groupId?id=${id}`,
      method: 'DELETE'
    })
  },
  productGroup: (data) => {
    return request({
      url: 'product/productGroup',
      method: 'POST',
      data
    })
  },
  setListingTime: (data) => {
    return request({
      url: 'product/setListingTime',
      method: 'POST',
      data
    })
  },
  setDownshareListingTime: (data) => {
    return request({
      url: 'product/setDownshareListingTime',
      method: 'POST',
      data
    })
  },
  
  setParentIds: (data) => {
    return request({
      url: `product/setParentIds`,
      method: 'POST', 
      data     
    })
  },
  setFabricParentIds: (data) => {
    return request({
      url: `product/setFabricParentIds`,
      method: 'POST', 
      data  
    })
  },
  unsetproductGroup: (data) => {
    return request({
      url: 'product/unsetproductGroup',
      method: 'POST',
      data
    })
  },
  
  getProductGroup: (orgid,id) => {
    return request({
      url: `product/productGroup?orgid=${orgid}&id=${id}`,
      method: 'GET'
    })
  },
  getInstores: (data) => {
    return request({
      url: 'product/allPrdInventoryIn',
      method: 'POST',
      data
    })
  },//prdInventoryInOut
  getInventoryInOut: (data) => {
    return request({
      url: 'product/prdInventoryInOut',
      method: 'POST',
      data
    })
  },
  getOutstores: (data) => {
    return request({
      url: 'product/allPrdInventoryOut',
      method: 'POST',
      data
    })
  },
  getStores: (data) => {
    return request({
      url: 'product/allPrdInventory',
      method: 'POST',
      data
    })
  },
  addPrdInventoryOut: (data) => {
    return request({
      url: 'product/addPrdInventoryOut',
      method: 'POST',
      data
    })
  },
  addPrdInventoryIn: (data) => {
    return request({
      url: 'product/addPrdInventoryIn',
      method: 'POST',
      data
    })
  },
  getProductSizes: (id,orgid) => {
    return request({
      url: `land/productsizes?prdid=${id}&orgid=${orgid}`,
      method: 'GET',
    })
  },
  updateAttachSize: (id,size) => {
    return request({
      url: `product/updateAttachSize?id=${id}&size=${size}`,
      method: 'GET'
    })
  },
  getExcelDataById: (id) => {
    return request({
      url: `product/excelDataById?id=${id}`,
      method: 'GET'
    })
  },
  getAttachFile: (id,callback) => {
    const myHeaders = new Headers();
      myHeaders.append("token", store.getters.token);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      fetch(process.env.VUE_APP_BASE_API+`/product/downloadProductAttach?id=${id}`, requestOptions as any)
        .then(response => {
          if (!response.ok) {
            throw new Error(`网络错误！状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          if(callback){
            callback(blob)
          }          
        })
        .catch(operationFailureHandler('下载未完成，请检查网络后重试。'));
  },
  operationLog:(data)=> {
    return request({
      url: 'system/operationLog',
      method: 'POST',
      data
    }) 
  },
}

